var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#A93AFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22C6.977 22 2.5 17.523 2.5 12C2.5 6.477 6.977 2 12.5 2C18.023 2 22.5 6.477 22.5 12C22.5 17.523 18.023 22 12.5 22ZM17.32 17.076C18.5271 15.9319 19.2874 14.3953 19.4647 12.7416C19.6419 11.0879 19.2246 9.4251 18.2874 8.05111C17.3503 6.67711 15.9545 5.6817 14.3502 5.24319C12.7458 4.80468 11.0378 4.95173 9.532 5.658L10.507 7.413C11.2679 7.08229 12.0992 6.94613 12.9259 7.01679C13.7525 7.08746 14.5486 7.36273 15.2424 7.81779C15.9361 8.27286 16.5057 8.89341 16.8999 9.62351C17.294 10.3536 17.5002 11.1703 17.5 12H14.5L17.32 17.076ZM15.468 18.342L14.493 16.587C13.7321 16.9177 12.9008 17.0539 12.0741 16.9832C11.2475 16.9125 10.4514 16.6373 9.75762 16.1822C9.06386 15.7271 8.49425 15.1066 8.10013 14.3765C7.70601 13.6464 7.49977 12.8297 7.5 12H10.5L7.68 6.924C6.47289 8.06814 5.7126 9.60469 5.53532 11.2584C5.35805 12.9121 5.77539 14.5749 6.71256 15.9489C7.64974 17.3229 9.04552 18.3183 10.6498 18.7568C12.2542 19.1953 13.9622 19.0483 15.468 18.342Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.16545652a651b137ffecca4a530d972d.svg";
export { ForwardRef as ReactComponent };